import React, { useState, useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import { withFirebase } from '../../../../firebase';
import { withRouter } from 'react-router-dom';

import { reorder } from '../other';
import { updateCategories, updateCategoriesOrder } from '../../../../reducers/shops';
import SortCategories from './sortCategories';

const SortModeProducts = (props) => {
    const categories = useSelector(state => state.shops.categories);
    const language = useSelector(state => state.shops.defaultLanguage);
    const languages = useSelector(state => state.shops.languages);
    const categoriesOrder = useSelector(state => state.shops.categoriesOrder);
    const state = useSelector(state => state);

    const [openModal, setOpenModal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [submitData, setSubmitData] = useState(null);
    const [categoriesList, setCategoriesList] = useState(null);
    // const [categoriesOrder, setCategoriesOrder] = useState(null);
    const isDebug = JSON.parse(localStorage.getItem('isDebug'))

    const handleClose = () => {
        setOpenModal(false);
        setIsSubmit(false);
    };

    const handleClickSubmit = () => {
        setOpenModal(false);
        setIsSubmit(true);
    };

    const getCategoriesList = () => {
        let data = [];
        let listData = {};

        for (let id in categories) {
            if (categoriesOrder && categoriesOrder.length > 0) {
                for (let key in categoriesOrder) {
                    console.log('categoriesOrder[key]', categoriesOrder[key]);
                    console.log('id -->>>', id);
                    if (categoriesOrder[key] !== id) {
                      listData[id] = categories[id]
                    }
                  }
            } else {
                listData[id] = categories[id]
            }
        }

        for (let key in listData) {
            let item = { id: key, name: categories[key].name[language] };
            data.push(item);
        }

        if (data.length > 0) setCategoriesList(data);

    }

    const sortCategories = (ids) => {
        const categoriesIds = [ ...ids ];
        let data = {};

        if (categoriesOrder) {
            let categoriesOrders = [];
            const categoriesOrderIds = Object.values(categoriesOrder);

            categoriesIds.map(id => {
            categoriesOrderIds.map(orderId => {
                if (orderId === id) {
                categoriesOrders.push(id);
                }
            });
            });

            for (let key in categoriesOrders) {
            if (categories[categoriesOrder[key]]) {
                data[categoriesOrder[key]] = categories[categoriesOrder[key]]
            }
            }
        }

        console.log('data --->>>', data);

        if (data) props.updateCategories(data);
    }

    // useEffect(() => {
    //     if (!categoriesOrder) {
    //         props.firebase.bd.ref('settings/Category/categoriesOrder').once("value", (snapshot) => {
    //             let data = snapshot.val();
        
    //             if (data) setCategoriesOrder(data);
    //         });
    //     }
    // }, [categoriesOrder]);

    useEffect(() => {
        if (isSubmit) {
            handleSubmit(submitData);
            setOpenModal(false);
        };
    }, [isSubmit]);

    useEffect(() => {
        if (!categoriesList && categories && categoriesOrder) getCategoriesList();
        if (!categoriesList && categories && !categoriesOrder) getCategoriesList();
    }, [categoriesList, categories, categoriesOrder]);

    const onDragEnd = (result) => {
        if (!result.destination) {
          return;
        }

        let data = reorder(
          categoriesList,
          result.source.index,
          result.destination.index,
        );

        let sortData = [];
        data.map((item) => sortData.push(item.id));

        console.log('sortData --->>>', sortData);
        console.log('data --->>>', data);

        setCategoriesList(data);
        setSubmitData(sortData);

        // console.log('data', data);
    }

    const getCategories = (categoriesOrder) => {
        let list = [];
        let listCategories = {};

        let itemKeys = Object.keys(categories);
        let itemValues = Object.values(categories);

        for (let index in categoriesOrder) {
            if (itemKeys.includes(categoriesOrder[index])) {
                const itemIndex = itemKeys.findIndex(t => t === categoriesOrder[index]);
                const item = itemValues[itemIndex];

                let name = {};

                for (let key in languages) {
                    console.log('key', languages[key]);
                    if (languages[key].key == language) {
                        name[language] = item.name[language];
                    } 
                }

                list.push({
                    name,
                    id: categoriesOrder[index],
                    spots: item.spots
                });

                listCategories[categoriesOrder[index]] = {
                    name,
                    id: categoriesOrder[index],
                    spots: item.spots
                }
            }
        }
        console.log('listCategories', listCategories);
        props.updateCategories(listCategories);
    }

    const clearStateByProducts = () => {
        setIsSubmit(false);
        setSubmitData(null);
        // setCategoriesOrder(null);
        // setCategoriesList(null);
    };

    const sendToUpdateFirebase = (data) => {
        props.firebase.bd.ref(`${isDebug ? 'debug' : ''}/settings/Category/categoriesOrder`).set(data)
            .then(res => {
                clearStateByProducts();
                updateCategoriesOrder(data);
                getCategories(data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const handleSubmit = (data) => {
        console.log('submit data', data);

        if (!data) {
            clearStateByProducts();
        } else {
            sendToUpdateFirebase(data);
        }
    }

    // console.log('state -->>>', state);

    return (
        <SortCategories 
            openModal={openModal}
            categoriesList={categoriesList}
            handleClose={handleClose}
            handleClickSubmit={handleClickSubmit}
            onDragEnd={onDragEnd}
            setOpenModal={setOpenModal}
        />
    )
}

export default connect(null, { updateCategories, updateCategoriesOrder, updateCategories })(withRouter(withFirebase(SortModeProducts)));